import StaffMessaging from "@/components/messaging/StaffMessaging";

export default function NurseMessaging() {
  return <StaffMessaging defaultRecipientType="patient" />;
}
